/**
 * Metadatos de la aplicación.
 */
export const APP_META = {
  name: 'EDSuite Web',
  /**
   * Versión publicada de EDSuite. Sale de `package.json` (ver `vite.config.ts`):
   * es el número que muestran el login y el pie del panel.
   */
  version: __APP_VERSION__,
  vendor: 'Escienza',
  vendorUrl: 'https://escienza.pe',
  /** Mesa de ayuda para el enlace de "Soporte técnico" del panel. */
  supportUrl: 'https://soporte.escienza.com.pe/',
} as const;
